"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PillVariants = exports.PillSizes = exports.PillShapes = void 0;
var PillVariants = {
  Success: "success",
  Alert: "alert",
  Warning: "warning",
  Disabled: "disabled"
};
exports.PillVariants = PillVariants;
var PillShapes = {
  Round: "round",
  Rectangle: "rectangle"
};
exports.PillShapes = PillShapes;
var PillSizes = {
  Small: "small"
};
exports.PillSizes = PillSizes;